import React, { useEffect, useState } from 'react'
import { Modal, Button } from '@scuf/common'
import CytoscapeComponent from 'react-cytoscapejs'
import baseServices from '../../../services/base.services'

import useWidth from './useWidth'
import ConoDomo2 from './ConoDomo2'

const PilaDomo2 = () => {

    const { windowDimensions } = useWidth(null)

    const [state, setstate] = useState(null)
    const stateCono = useState(null)
    const [stateModal, setstateModal] = useState(false)

    const fPair = (index) => {

        if (index === 0) return 'Cono' + ((index + 1) * 2).toString()
        else return 'Cono' + ((index + 1) * 2).toString()
    }

    useEffect(() => {
    const fData = async () => {
        
            let auxArray = []
            try {
                var response = await baseServices.getTostacionModeloDomo({ opcion: 1 })
                if (response.data && response.data.length > 0) {
                    response.data.forEach((element, index) => {
                        auxArray.push(fArrayNode(1, index, fPair(index), element.Theta, element.Reclamacion, element))  
                                    
                    });

                    setstate(auxArray)   
                    }
                

            }
            catch (e) {
                console.log(e)
            }
        }
        fData();
    }, [])

    const style = [{
        selector: 'edge', //Flechas
        css: {
            'width': 1.5,
            "curve-style": "bezier",
            'target-arrow-shape': 'triangle',
            'label': 'data(label)',
            "text-rotation": "autorotate",
            "text-margin-x": "3px",
            "text-margin-y": "-2px",
            "font-size": '8px',
            "font-weight": '500',
            "color": 'white'
        }

    },
    {
        selector: 'node.highlight',
        style: {
            'border-color': '#FFF',
            'border-width': '2px'
        }
    },
    
    {
        selector: 'node.semitransp',
        style: { 'opacity': '0.5' }
    },
    {
        selector: 'edge.highlight',
        style: { 'mid-target-arrow-color': '#FFF' }
    },
    {
        selector: 'edge.semitransp',
        style: { 'opacity': '0.2' }
    }
    ]

    const fArrayNode = (sumaResta, index, name, Theta, principal, data) => {
        return {
            group: 'nodes',
            data: { id: name, data: data, label: index, classes: 'bottom-center', style: { 'color': 'yellow' } },
            selected: true, 
            //position: { x: (index + 1) * 12 * sumaResta, y: 50 + index * 4 },
            position: { x: index * 20, y: 50 },
            locked: true,
            style: {
                'width': '36px',
                'height': '36px',
                'margin': '10px',
                'clear': 'right',
                'display': 'block',
                'white-space': 'pre',
                'background-image': principal === '' ? 'url(../../../../assets/IconEthernet/cono1.2.png)' : 'url(../../../../assets/IconEthernet/cono1.2blue.png)',
                "background-fit": "cover cover",
                'background-opacity': '0',
                //'background-opacity': principal == '' ? '0' : '0.5',
                'content': Theta + '°',
                'font-size': '5px',
                'color':'white',
                'fontWeight': '700'
            }
        }
    }

    return (
        <>
            {stateCono &&
                <Modal
                    className="popup-theme-wrap"
                    size="large"
                    open={stateModal}
                    scrolling={false}
                    closeOnDocumentClick={true}
                    style={{ height: '600px' }}
                >
                    <Modal.Content>
                        <ConoDomo2 datos={stateCono} />
                    </Modal.Content>
                    <Modal.Footer style={{ marginTop: '0px' }}>
                        <Button type="secondary" content="Secondary" size="small" onClick={() => setstateModal(false)}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            }
            {
                state && <>
                <div>
                <CytoscapeComponent
                    className='cyto'
                    elements={state}
                    stylesheet={style}
                    layout={{ name: 'preset' }}
                    minZoom={2}
                    maxZoom={4}
                    cy={(cy) => {

                        cy.on('tap', 'node', function (evt) {
                           // console.log(evt.target.id())
                            //fprueba(evt.target.id())
                            //cy.removeListener('tap')
                        })
                        cy.on('mouseover', 'node', function (e) {
                            console.log(e.target.data()); 
                            let data = e.target.data()                   
                            var sel = e.target;
                            cy.elements()
                                .difference(sel.outgoers()
                                    .union(sel.incomers()))
                                .not(sel)
                                .addClass('semitransp');
                                
                            sel.addClass('highlight')
                                .outgoers()
                                .union(sel.incomers())
                                .addClass('highlight');
                            

                            console.log(data)      
                            document.getElementById('label-data').style.display = 'block';   
                            document.getElementById('label-data').innerHTML = `
                            Theta: ${data.data.Theta}° </br>
                            Inicio: ${data.data.IniTime} </br>
                            Fin: ${data.data.EndTime} </br>
              
                            Masa: ${data.data.Masa} </br>
                            Arsenico: ${data.data.Arsenico} </br>
                            Ganga: ${data.data.Ganga} </br>
                            Reactivos: ${data.data.Reactivos} </br>
                             
                            `;
                                
                        })
                        cy.on('mouseout', 'node', function (e) {
                            var sel = e.target;
                            cy.elements()
                                .removeClass('semitransp');
                            sel.removeClass('highlight')
                                .outgoers()
                                .union(sel.incomers())
                                .removeClass('highlight');
                            document.getElementById('label-data').style.display = 'none';

                        })
                        if (windowDimensions.width < 501) cy.panningEnabled(true)
                        else cy.panningEnabled(false)
                        cy.center()

                    }}
                />
                </div>
                <div style={{padding:'5px', backgroundColor:'black', color:'white', 
                lineHeight: '1.2',
                marginTop:'-15px',
                border:'1px solid gray', 
                position:'absolute',
                right:'0px',
                width:'230px', fontSize:'12px'}} id='label-data'>Deslice el mouse sobre la pila</div>
                </>
            }
        </>
    )
}

export default PilaDomo2